<template>
 <el-dialog
      :title="thestation"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      width="48%">
      <div class="block" v-loading="false">
        <el-radio v-model="radio" label="1" @change="hour()">小时</el-radio>
        <el-radio v-model="radio" label="2" @change="minute()">分钟</el-radio>
        <el-button @click="beforeDate" v-show="dateselect">前一天</el-button>
        <span class="demonstration"></span>
        <el-date-picker
          v-model="datev"
          v-show="dateselect"
          type="date"
          placeholder="选择日期"
          @change="datechange">
        </el-date-picker>
        <el-button @click="afterDate" v-show="dateselect">后一天</el-button>
      </div>
      <div v-loading="loading1" id="station"></div>
    </el-dialog>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import monitorTypes from '@/store/types/monitor'
import config from '@/config'
// import config from '@/config'

export default {
  name: 'rainWaterProcess',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      loading: true,
      loading1: true,
      height: 10,
      // choosed: 0,
      aDDVCD: '330621',
      stationName: '',
      isTown: true,
      searchName: '',
      tdata: [],
      tdata2: [],
      all: true,
      adcdtotal: '',
      pageIndex: 1,
      pageSize: 100,
      towns: [],
      checkarr: [],
      inputData: '',
      time: '',
      chartwaterValues: [],
      chartxline: [],
      chartwrZs: [],
      chartrainValues: [],
      datev: '',
      radio: '1',
      dateselect: true,
      sID: 3,
      myChart: {},
      dialogVisible: this.waterDialogVisible,
      thestation: ''
    }
  },
  props: {
    sTID: {},
    waterDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    waterDialogVisible (val) {
      this.dialogVisible = val
    }
  },
  // 方法集合
  methods: {
    beforeDate () {
      let day1 = new Date(this.datev)
      day1.setTime(day1.getTime() - 1 * 24 * 60 * 60 * 1000)
      this.datev = day1.getFullYear() + '-' + (day1.getMonth() + 1) + '-' + day1.getDate()
      this.datechange()
    },
    afterDate () {
      let day2 = new Date(this.datev)
      day2.setTime(day2.getTime() + 1 * 24 * 60 * 60 * 1000)
      this.datev = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate()
      this.datechange()
    },
    minute () {
      this.myChart.clear()
      this.loading1 = true
      this.dateselect = false
      this.chartwaterValues = []
      this.chartrainValues = []
      this.chartwrZs = []
      this.chartxline = []
      var date = new Date()
      // 年
      var year = date.getFullYear()
      // 月
      var month = date.getMonth() + 1
      // 日
      var day = date.getDate()
      var hh = date.getHours()
      // 分
      var mm = date.getMinutes()
      var rq = year + '-' + month + '-' + day + ' ' + hh + ':' + mm
      this.time = rq
      this.datev = rq
      this.dialogVisible = true
      this.$store.dispatch(monitorTypes.GET_RAINWATERMINUTESTOTAL, {
        sID: 3,
        sTID: this.sTID,
        time: this.time
      }).then(data => {
        this.chartwaterValues = data.waterValues
        this.chartrainValues = data.rainValues
        this.chartwrZs = data.wrZs
        this.chartxline = data.tMs
        this.thestation = data.stnm
        this.startWaterMark = data.startWaterMark
        this.loading1 = false
        this.drawChart(this.chartwaterValues, this.chartrainValues, this.chartwrZs, this.chartxline, this.thestation)
      })
    },
    hour () {
      this.myChart.clear()
      this.loading1 = true
      this.dateselect = true
      this.chartwaterValues = []
      this.chartrainValues = []
      this.chartwrZs = []
      this.chartxline = []
      var date = new Date()
      // 年
      var year = date.getFullYear()
      // 月
      var month = date.getMonth() + 1
      // 日
      var day = date.getDate()
      var rq = year + '-' + month + '-' + day
      this.time = rq
      this.datev = rq
      this.dialogVisible = true
      this.$store.dispatch(monitorTypes.GET_RAIN_WATER_TOTAL, {
        sID: 3,
        sTID: this.sTID,
        time: this.time
      }).then(res => {
        this.chartwaterValues = res.waterValues
        this.chartrainValues = res.rainValues
        this.chartwrZs = res.wrZs
        this.chartxline = res.tMs
        this.thestation = res.stnm
        this.startWaterMark = res.startWaterMark
        this.loading1 = false
        this.drawChart(this.chartwaterValues, this.chartrainValues, this.chartwrZs, this.chartxline, this.thestation)
      })
    },
    stationchart () {
      // console.log(this.sTID)
      this.dateselect = true
      this.loading1 = true
      this.radio = '1'
      this.chartwaterValues = []
      this.chartrainValues = []
      this.chartwrZs = []
      this.chartxline = []
      this.thestation = ''
      var date = new Date()
      // 年
      var year = date.getFullYear()
      // 月
      var month = date.getMonth() + 1
      // 日
      var day = date.getDate()
      var rq = year + '-' + month + '-' + day
      this.time = rq
      this.datev = rq
      this.$axios.get(config.ApiYJ + '/HydrologyCenter/GetRainWaterTotal', {
        params: {
          sID: this.sID,
          sTID: this.sTID,
          time: this.time
        }
      }).then(res => {
        this.loading1 = false
        this.chartwaterValues = res.data.waterValues
        this.chartrainValues = res.data.rainValues
        this.chartwrZs = res.data.wrZs
        this.chartxline = res.data.tMs
        this.thestation = res.data.stnm
        this.startWaterMark = res.data.startWaterMark
        this.drawChart(this.chartwaterValues, this.chartrainValues, this.chartwrZs, this.chartxline, this.thestation)
      })
    },
    datechange () {
      this.time = this.datev
      this.myChart.clear()
      this.loading1 = true
      this.chartwaterValues = []
      this.chartrainValues = []
      this.chartwrZs = []
      this.chartxline = []
      this.dialogVisible = true
      this.$axios.get(config.ApiYJ + '/HydrologyCenter/GetRainWaterTotal', {
        params: {
          sID: 3,
          sTID: this.sTID,
          time: this.time
        }
      }).then(res => {
        this.loading1 = false
        this.chartwaterValues = res.data.waterValues
        this.chartrainValues = res.data.rainValues
        this.chartwrZs = res.data.wrZs
        this.chartxline = res.data.tMs
        this.thestation = res.data.stnm
        this.startWaterMark = res.data.startWaterMark
        this.drawChart(this.chartwaterValues, this.chartrainValues, this.chartwrZs, this.chartxline, this.thestation)
      })
    },
    // 折线图
    drawChart (chartwaterValues, chartrainValues, chartwrZs, chartxline, thestation) {
      let myChart = this.$echarts.init(document.getElementById('station'))
      this.myChart = myChart
      myChart.clear()
      myChart.setOption({
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['雨量', '水位', '警戒水位'],
          orient: 'vertical',
          x: 'left',
          y: 'center',
          padding: [0, 30, 0, 0],
          itemWidth: 10
        },
        grid: {
          top: '10%',
          left: '10%',
          right: '4%',
          bottom: '12%'
        },
        xAxis: [
          {
            type: 'category',
            // boundaryGap: false,
            data: chartxline,
            axisLabel: {
              interval: 2,
              formatter: function (params) {
                var newParamsName = ''
                var paramsNameNumber = params.length
                var provideNumber = 6
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                if (paramsNameNumber > provideNumber) {
                  for (var p = 0; p < provideNumber; p++) {
                    var tempStr = ''
                    var start = p * provideNumber
                    var end = start + provideNumber
                    if (p === rowNumber - 1) {
                      tempStr = params.substring(start, paramsNameNumber)
                    } else {
                      tempStr = params.substring(start, end) + '\n'
                    }
                    newParamsName += tempStr
                  }
                } else {
                  newParamsName = params
                }
                return newParamsName
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '水位',
            min: this.startWaterMark,
            scale: true,
            interval: 100,
            axisLabel: {
              formatter: '{value} m'
            }
          },
          {
            type: 'value',
            name: '雨量',
            max: function (value) {
              return Math.round(value.max * 1.5)
            },
            nameLocation: 'start',
            inverse: true, // 翻转
            interval: 30,
            axisLabel: {
              formatter: '{value} mm'
            }
          }
        ],
        series: [
          {
            name: '雨量',
            type: 'bar',
            yAxisIndex: 1,
            itemStyle: {
              color: '#33C9DE'
            },
            data: chartrainValues
          },
          {
            name: '水位',
            type: 'line',
            itemStyle: {
              color: '#15d186'
            },
            symbol: 'circle',
            symbolSize: 10,
            lineStyle: {
              width: 3
            },
            data: chartwaterValues
          },
          {
            name: '警戒水位',
            type: 'line',
            symbol: 'none',
            itemStyle: {
              color: '#f4e74c'
            },
            lineStyle: {
              width: 3
            },
            data: chartwrZs
          }
        ]
      })
    },
    handleClose () {
      this.$emit('update:waterDialogVisible', false)
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
#station{
  width: 100%;
  height: 280px;
}
.block{
  width: 100%;
  text-align: center;
}
</style>
